export default __webpack_public_path__ + "static/media/file-download.cf88af5b.svg";